<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {
      height: window.innerHeight,
      width: window.innerWidth,
      x: null,
      y: null,
      interval: null,
    };
  },
  mounted() {
    document.addEventListener("mousemove", e => {
      // in Internet Explorer 11 and below, if there is any zoom factor applied, the mouse coordinates come back as doubles
      var xInt = 0;
      var yInt = 0;

      try {
        xInt = Math.round(e.pageX);
      } catch (error) {
        console.log(error);
      }

      try {
        yInt = Math.round(e.pageY);
      } catch (error) {
        console.log(error);
      }

      this.x = xInt;
      this.y = yInt;
    });

    this.interval = setInterval(() => this.$emit("mouseLocation", this.x, this.y), 100);
  },
  destroy() {
    if (this.interval) clearInterval(this.interval);
  },
};
</script>
